import React, { useMemo } from "react";
import { ParsedCustomizationType, parseOrderItemCustomizationContent } from "@/dto/order/CustomizationInfoDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderDTO from "@/dto/order/OrderDTO";
import CustomizationColumnV1 from "./CustomizationColumnV1";
import PhoneCaseCustomizationInfoColumn from "./PhoneCaseCustomizationInfoColumn";
import { observer } from "mobx-react-lite";

interface CustomizationColumnProps {
    order: OrderDTO;

    orderItem: OrderItemDTO;

    isSupplierShop?: boolean;
}

const CustomizationColumn: React.FC<CustomizationColumnProps> = observer(function (props) {
    const { order, orderItem } = props;

    const result = useMemo(() => parseOrderItemCustomizationContent(orderItem?.customizationInfo?.content), [
        orderItem?.customizationInfo?.content,
    ]);

    if (result.type === ParsedCustomizationType.LH_CUSTOMIZATION_V1) {
        return (
            <CustomizationColumnV1 order={order} orderItem={orderItem} customizationInfos={result.customizationInfos} />
        );
    }

    if (result.type === ParsedCustomizationType.PHONE_CASE_CUSTOMIZATION_V2) {
        return <PhoneCaseCustomizationInfoColumn phoneCaseCustomizationInfos={result.phoneCaseCustomizationInfos} />;
    }

    return null;
});

export default CustomizationColumn;
